export default __webpack_public_path__ + "static/DUI-1d724a39c01719608be4c880c1227705.png";